import UserMenu from "../components/common/UserMenu";
import defaultAvatar from "../assets/logo/logo.png";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { resolveMedia } from "../services/api";
import { Menu } from "lucide-react";

export default function Header({ onToggleSidebar }) {
  const { user, logoutUser, loading } = useAuth();
  const navigate = useNavigate();
  

  function handleLogout() {
    logoutUser();
    navigate("/login");
    
  }

  if (loading || !user) return null;

  const avatar = resolveMedia(user.profilPicture, defaultAvatar);
  const fullName = `${user.firstName} ${user.lastName}`;
  const roleName = user.role?.name;

  return (
    <header className="header">
      {/* LEFT */}
      <div className="headerLeft">
        <button className="iconBtn sidebarToggle" onClick={onToggleSidebar}>
          
          <Menu size={22} />
        </button>
      </div>

      {/* RIGHT */}
      <div className="headerRight headerUserOnly">
        <UserMenu
          avatar={avatar}
          name={fullName}
          role={roleName}
          onLogout={handleLogout}
        />
      </div>
    </header>
  );
}
